import React, { useState } from 'react';
import './CalculatorPage.css';

function PhoneNumberOfChangeRecommendation() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const analyzePhoneNumber = (number) => {
    // Placeholder for Phone Number Change Recommendation logic
    // This is a simplified example; real analysis would be more complex.
    if (!number) return null;
    const digits = number.replace(/\D/g, '');
    if (digits.length < 10) return "Please enter a valid 10-digit phone number.";

    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
      sum += parseInt(digits[i], 10);
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }

    if (sum === 6 || sum === 8) {
      return `The numerological value of your phone number is ${sum}. This number is generally considered favorable.`;
    } else if (sum === 4 || sum === 7) {
      return `The numerological value of your phone number is ${sum}. You might consider a change for better alignment.`;
    } else {
      return `The numerological value of your phone number is ${sum}. This number has a neutral influence.`;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!phoneNumber) {
      setError('Please enter a phone number.');
      return;
    }

    const calculated = analyzePhoneNumber(phoneNumber);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Phone Number Change Recommendation",
    "description": "Get numerological recommendations for changing your phone number.",
    "url": "https://www.yourwebsite.com/phone-number-change-recommendation",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Get Phone Number Recommendation",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/phone-number-change-recommendation?phoneNumber={phoneNumber}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=phoneNumber"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Phone Number Change Recommendation</h1>
      <p className="text-center">Enter your phone number to get a numerological recommendation.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number:</label>
          <input
            type="text"
            id="phoneNumber"
            className="form-control"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="e.g., 1234567890"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Get Recommendation</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Recommendation:</h2>
          <p className="result-explanation">{result}</p>
        </div>
      )}
    </div>
  );
}

export default PhoneNumberOfChangeRecommendation;
